import {aMonto, ivaSobreBase, precioUnitarioNeto, redondear2} from './calculo-dte'

export interface EntradasLiquidacion {
  montoOperaciones: any
  montoSinPercepcion: any
  porcentajeComision: any
}

export interface CalculosLiquidacion {
  valorOperaciones: number
  valoresNoSujetosAPercepcion: number
  subtotal: number
  montoSujetoAPercepcionSinIVA: number
  ivaOperacionesALiquidar: number
  ivaPercibido: number
  porcentajeComision: number
  comision: number
  ivaComision: number
  valorLiquidoAPagarAlAfiliado: number
}

export const TASA_PERCEPCION = 0.02

export const calculosLiquidacion = (entradas: EntradasLiquidacion): CalculosLiquidacion => {
  const valorOperaciones = redondear2(entradas.montoOperaciones)
  const valoresNoSujetosAPercepcion = redondear2(entradas.montoSinPercepcion)
  const subtotal = redondear2(valorOperaciones - valoresNoSujetosAPercepcion)
  const montoSujetoAPercepcionSinIVA = precioUnitarioNeto(subtotal, true)
  const ivaOperacionesALiquidar = ivaSobreBase(montoSujetoAPercepcionSinIVA)
  const ivaPercibido = redondear2(montoSujetoAPercepcionSinIVA * TASA_PERCEPCION)
  const porcentajeComision = aMonto(entradas.porcentajeComision)
  const comision = redondear2((montoSujetoAPercepcionSinIVA * porcentajeComision) / 100)
  const ivaComision = ivaSobreBase(comision)
  const valorLiquidoAPagarAlAfiliado = redondear2(
    valorOperaciones - comision - ivaPercibido - ivaComision
  )

  return {
    valorOperaciones,
    valoresNoSujetosAPercepcion,
    subtotal,
    montoSujetoAPercepcionSinIVA,
    ivaOperacionesALiquidar,
    ivaPercibido,
    porcentajeComision,
    comision,
    ivaComision,
    valorLiquidoAPagarAlAfiliado,
  }
}
